import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE_PATH,
  routes: [
    { path: '/', component: () => import("../pages/Home"), meta: { tutorial: 'HOME' } },
    { path: '/accountRegistration1', component: () => import("../pages/AccountRegistration1") },
    { path: '/accountRegistration3', component: () => import("../pages/AccountRegistration3") },
    { path: '/album', component: () => import("../pages/Album"), meta: { tutorial: 'ALBUM' } },
    { path: '/birthDateChange/:month/:year', component: () => import("../pages/BirthDateChange"), name: "birthDateChange" },
    { path: '/birthDateChangeFinish/:month/:year', component: () => import("../pages/BirthDateChangeFinish"), name: "birthDateChangeFinish" },
    { path: '/couponList', component: () => import("../pages/CouponList") },
    { path: '/couponHistory', component: () => import("../pages/CouponHistory") },
    { path: '/couponGet', component: () => import("../pages/CouponGet") },
    { path: '/couponHelp', component: () => import("../pages/CouponHelp") },
    { path: '/detail/', component: () => import("../pages/Detail"), name: "detail" },
    { path: '/download', component: () => import("../pages/Download"), meta: { tutorial: 'PURIDL' } },
    { path: '/downloadFinish', component: () => import("../pages/DownloadFinish"), name: "dlfinish", props: true },
    { path: '/error/:title/:statusCode', component: () => import("../pages/Error") },
    { path: '/freeMemberRemoval1', component: () => import("../pages/FreeMemberRemoval1") },
    { path: '/freeMemberRemoval1/:playerId', component: () => import("../pages/FreeMemberRemoval1") },
    { path: '/freeMemberRemoval2', component: () => import("../pages/FreeMemberRemoval2") },
    { path: '/freeMemberRemovalFinish', component: () => import("../pages/FreeMemberRemovalFinish") },
    { path: '/AppfreeMemberRemovalFinish', component: () => import("../pages/AppFreeMemberRemovalFinish"), name: "Appfreememberremovalfinish", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/help', component: () => import("../pages/Help"), },
    { path: '/Application', component: () => import("../pages/Application"), },
    { path: '/AboutApplication', component: () => import("../pages/AboutApplication"), },
    { path: '/faq', component: () => import("../pages/Faq"), },
    { path: '/Appfaq', component: () => import("../pages/AppFaq"), name: "AppFaq", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/aboutWeb', component: () => import("../pages/AboutWeb"), },
    { path: '/aboutWeb01', component: () => import("../pages/AboutWeb01"), },
    { path: '/aboutWeb02', component: () => import("../pages/AboutWeb02"), },
    { path: '/aboutWeb03', component: () => import("../pages/AboutWeb03"), },
    { path: '/aboutWeb04', component: () => import("../pages/AboutWeb04"), },
    { path: '/aboutWeb05', component: () => import("../pages/AboutWeb05"), },
    { path: '/aboutWeb06', component: () => import("../pages/AboutWeb06"), },
    { path: '/aboutWeb07', component: () => import("../pages/AboutWeb07"), },
    { path: '/aboutWeb08', component: () => import("../pages/AboutWeb08"), },
    { path: '/aboutWeb09', component: () => import("../pages/AboutWeb09"), },
    { path: '/aboutWeb10', component: () => import("../pages/AboutWeb10"), },
    { path: '/aboutARpuri', component: () => import("../pages/AboutARpuri.vue"), },
    { path: '/AppAboutARpuri', component: () => import("../pages/AppAboutARpuri.vue"), name: "appaboutarpuri", meta: { headerDisabled: true, footerDisabled: true }  },
    { path: '/AboutAppsubscription', component: () => import("../pages/AboutAppsubscription.vue"), },
    { path: '/AppAboutAppsubscription', component: () => import("../pages/AppAboutAppsubscription.vue"), name: "AppAboutAppsubscription", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/aboutFiz', component: () => import("../pages/AboutFiz"), },
    { path: '/aboutFiz01', component: () => import("../pages/AboutFiz01"), },
    { path: '/aboutFiz02', component: () => import("../pages/AboutFiz02"), },
    { path: '/aboutFiz03', component: () => import("../pages/AboutFiz03"), },
    { path: '/AppaboutWeb', component: () => import("../pages/AppAboutWeb"), name: "appaboutWeb", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb01', component: () => import("../pages/AppAboutWeb01"), name: "appaboutWeb01", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb02', component: () => import("../pages/AppAboutWeb02"), name: "appaboutWeb02", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb02_1', component: () => import("../pages/AppAboutWeb02_1"), name: "appaboutWeb02_1", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb03', component: () => import("../pages/AppAboutWeb03"), name: "appaboutWeb03", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb04', component: () => import("../pages/AppAboutWeb04"), name: "appaboutWeb04", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb05', component: () => import("../pages/AppAboutWeb05"), name: "appaboutWeb05", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb06', component: () => import("../pages/AppAboutWeb06"), name: "appaboutWeb06", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb07', component: () => import("../pages/AppAboutWeb07"), name: "appaboutWeb07", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb08', component: () => import("../pages/AppAboutWeb08"), name: "appaboutWeb08", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb09', component: () => import("../pages/AppAboutWeb09"), name: "appaboutWeb09", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutWeb10', component: () => import("../pages/AppAboutWeb10"), name: "appaboutWeb10", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutFiz', component: () => import("../pages/AppAboutFiz"), name: "appaboutFiz", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutFiz01', component: () => import("../pages/AppAboutFiz01"), name: "appaboutFiz01", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutFiz02', component: () => import("../pages/AppAboutFiz02"), name: "appaboutFiz02", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutFiz03', component: () => import("../pages/AppAboutFiz03"), name: "appaboutFiz03", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AboutMeiyromantic', component: () => import("../pages/Aboutmeityromantic"), },
    { path: '/AboutMeiyromantic01', component: () => import("../pages/Aboutmeityromantic01"), },
    { path: '/AboutMeiyromantic02', component: () => import("../pages/Aboutmeityromantic02"), },
    { path: '/AboutMeiyromantic03', component: () => import("../pages/Aboutmeityromantic03"), },
    { path: '/AppAboutMeiyromantic', component: () => import("../pages/AppAboutmeityromantic"), name: "appaboutMeityromantic", meta: { headerDisabled: true, footerDisabled: true }},
    { path: '/AppAboutMeiyromantic01', component: () => import("../pages/AppAboutmeityromantic01"), name: "appaboutMeityromantic01", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppAboutMeiyromantic02', component: () => import("../pages/AppAboutmeityromantic02"), name: "appaboutMeityromantic02", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppAboutMeiyromantic03', component: () => import("../pages/AppAboutmeityromantic03"), name: "appaboutMeityromantic03", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AboutLalamee', component: () => import("../pages/AboutLalamee"), },
    { path: '/AboutLalamee01', component: () => import("../pages/AboutLalamee01"), },
    { path: '/AboutLalamee02', component: () => import("../pages/AboutLalamee02"), },
    { path: '/AboutLalamee03', component: () => import("../pages/AboutLalamee03"), },
    { path: '/AppaboutLalamee', component: () => import("../pages/AppAboutLalamee"), name: "appaboutLalamee", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutLalamee01', component: () => import("../pages/AppAboutLalamee01"), name: "appaboutLalamee01", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutLalamee02', component: () => import("../pages/AppAboutLalamee02"), name: "appaboutLalamee02", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutLalamee03', component: () => import("../pages/AppAboutLalamee03"), name: "appaboutLalamee03", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AboutROMAPI', component: () => import("../pages/AboutROMAPI"), },
    { path: '/AboutROMAPI01', component: () => import("../pages/AboutROMAPI01"), },
    { path: '/AboutROMAPI02', component: () => import("../pages/AboutROMAPI02"), },
    { path: '/AboutROMAPI03', component: () => import("../pages/AboutROMAPI03"), },
    { path: '/AppaboutROMAPI', component: () => import("../pages/AppaboutROMAPI"), name: "appaboutROMAPI", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutROMAPI01', component: () => import("../pages/AppaboutROMAPI01"), name: "appaboutROMAPI01", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutROMAPI02', component: () => import("../pages/AppaboutROMAPI02"), name: "appaboutROMAPI02", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutROMAPI03', component: () => import("../pages/AppaboutROMAPI03"), name: "appaboutROMAPI03", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AboutBepiu', component: () => import("../pages/AboutBepiu"), },
    { path: '/AboutBepiu01', component: () => import("../pages/AboutBepiu01"), },
    { path: '/AboutBepiu02', component: () => import("../pages/AboutBepiu02"), },
    { path: '/AboutBepiu03', component: () => import("../pages/AboutBepiu03"), },
    { path: '/AppaboutBepiu', component: () => import("../pages/AppaboutBepiu"), name: "appaboutBepiu", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutBepiu01', component: () => import("../pages/AppaboutBepiu01"), name: "appaboutBepiu01", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutBepiu02', component: () => import("../pages/AppaboutBepiu02"), name: "appaboutBepiu02", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutBepiu03', component: () => import("../pages/AppaboutBepiu03"), name: "appaboutBepiu03", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AboutRomakyun', component: () => import("../pages/AboutRomakyun"), },
    { path: '/AboutRomakyun01', component: () => import("../pages/AboutRomakyun01"), },
    { path: '/AboutRomakyun02', component: () => import("../pages/AboutRomakyun02"), },
    { path: '/AboutRomakyun03', component: () => import("../pages/AboutRomakyun03"), },
    { path: '/AppaboutRomakyun', component: () => import("../pages/AppaboutRomakyun"), name: "appaboutRomakyun", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutRomakyun01', component: () => import("../pages/AppaboutRomakyun01"), name: "appaboutRomakyun01", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutRomakyun02', component: () => import("../pages/AppaboutRomakyun02"), name: "appaboutRomakyun02", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutRomakyun03', component: () => import("../pages/AppaboutRomakyun03"), name: "appaboutRomakyun03", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AboutIMyMerry', component: () => import("../pages/AboutIMyMerry"), },
    { path: '/AboutIMyMerry01', component: () => import("../pages/AboutIMyMerry01"), },
    { path: '/AboutIMyMerry02', component: () => import("../pages/AboutIMyMerry02"), },
    { path: '/AboutIMyMerry03', component: () => import("../pages/AboutIMyMerry03"), },
    { path: '/AppaboutIMyMerry', component: () => import("../pages/AppaboutIMyMerry"), name: "appaboutIMyMerry", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutIMyMerry01', component: () => import("../pages/AppaboutIMyMerry01"), name: "appaboutIMyMerry01", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutIMyMerry02', component: () => import("../pages/AppaboutIMyMerry02"), name: "appaboutIMyMerry02", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppaboutIMyMerry03', component: () => import("../pages/AppaboutIMyMerry03"), name: "appaboutIMyMerry03", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/login', component: () => import("../pages/Login"), },
    { path: '/logout', component: () => import("../pages/Logout"), },
    { path: '/mailAddressChange', component: () => import("../pages/MailAddressChange") },
    { path: '/mailAddressChange/:playerId', component: () => import("../pages/MailAddressChange") },
    { path: '/mailAddressChange2', component: () => import("../pages/MailAddressChange2") },
    { path: '/mailAddressChangeConfirmation/:mailAddress', component: () => import("../pages/MailAddressChangeConfirmation"), name: "mailAddressChangeConfirmation" },
    { path: '/mailAddressChangeFinish', component: () => import("../pages/MailAddressChangeFinish"), name: "mailAddressChangeFinish", props: true },
    { path: '/member', component: () => import("../pages/Member"), meta: { tutorial: 'DIGITAL_PASS' }, props: true, name: 'member' },
    { path: '/memberBenefits', component: () => import("../pages/MemberBenefits") },
    { path: '/newsDetail/:id', component: () => import("../pages/NewsDetail"), name: "newsDetail" },
    { path: '/messageDetail/:id', component: () => import("../pages/MessageDetail"), name: "MessageDetail" },
    { path: '/appnewsDetail/:id', component: () => import("../pages/AppNewsDetail"), name: "appnewsDetail", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/newsTinyTAN', component: () => import("../pages/NewsTinytan"), name: "newsTinytan" },
    { path: '/newsTinyTAN_Butter', component: () => import("../pages/NewsTinyTAN_Butter"), name: "newsTinyTAN_Butter" },
    { path: '/news_TinyTAN_Sweet', component: () => import("../pages/NewsTinyTAN_Sweet"), name: "news_TinyTAN_Sweet" },
    { path: '/newsTXT', component: () => import("../pages/NewsTXT"), name: "newsTXT" },
    { path: '/newsBEFIRST', component: () => import("../pages/NewsBEFIRST"), name: "newsBEFIRST" },
    { path: '/newsD100', component: () => import("../pages/NewsD100"), name: "newsD100" },
    { path: '/news_TinyTAN_Permission', component: () => import("../pages/NewsTinyTAN_Permission"), name: "news_TinyTAN_Permission" },
    { path: '/news_P5T', component: () => import("../pages/NewsP5T.vue")},
    { path: '/newsPokePeace', component: () => import("../pages/NewsPokePeace"), name: "newsPokePeace" },
    { path: '/newsPeachShowtime', component: () => import("../pages/NewsPeachShowtime"), name: "newsPeachShowtime" },
    { path: '/newsList', component: () => import("../pages/NewsList") },
    { path: '/messageList', component: () => import("../pages/MessageList") },
    { path: '/appnewsList', component: () => import("../pages/AppNewsList"), meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/nicknameChange/', component: () => import("../pages/NicknameChange") },
    { path: '/nicknameChange/:nickname', component: () => import("../pages/NicknameChange"), name: "nicknameChange" },
    { path: '/nicknameChangeFinish/', component: () => import("../pages/NicknameChangeFinish") },
    { path: '/nicknameChangeFinish/:nickname', component: () => import("../pages/NicknameChangeFinish"), name: "nicknameChangeFinish" },
    { path: '/paidMemberChange', component: () => import("../pages/PaidMemberChange") },
    { path: '/paidMemberRegistrationSuccess', component: () => import("../pages/PaidMemberRegistrationFinish") },
    { path: '/paidMemberRegistrationFailure', component: () => import("../pages/PaidMemberRegistrationFinish") },
    { path: '/paidMemberRegistrationUpdate', component: () => import("../pages/PaidMemberRegistrationFinish") },
    { path: '/paidMemberRegistrationConsistency', component: () => import("../pages/PaidMemberRegistrationFinish") },
    { path: '/ApppaidMemberRegistrationSuccess', component: () => import("../pages/AppPaidMemberRegistrationFinish"), name: "apppaidmemberregistrationsuccess", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/ApppaidMemberRegistrationFailure', component: () => import("../pages/AppPaidMemberRegistrationFinish"), name: "apppaidmemberregistrationfailure", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/ApppaidMemberRegistrationUpdate', component: () => import("../pages/AppPaidMemberRegistrationFinish"), name: "apppaidmemberregistrationupdate", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/ApppaidMemberRegistrationConsistency', component: () => import("../pages/AppPaidMemberRegistrationFinish"), name: "apppaidmemberregistrationconsistency", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/paidMemberRemoval1', component: () => import("../pages/PaidMemberRemoval1") },
    { path: '/paidMemberRemoval2', component: () => import("../pages/PaidMemberRemoval2") },
    { path: '/paidMemberRemovalFinish', component: () => import("../pages/PaidMemberRemovalFinish") },
    { path: '/paidMemberSelect', component: () => import("../pages/PaidMemberSelect") },
    { path: '/passwordReset', component: () => import("../pages/PasswordChange") },
    { path: '/passwordChange', component: () => import("../pages/PasswordChange") },
    { path: '/passwordChange/:playerId', component: () => import("../pages/PasswordChange") },
    { path: '/passwordChangeFinish', component: () => import("../pages/PasswordChangeFinish") },
    { path: '/passwordForgot', component: () => import("../pages/PasswordForgot") },
    { path: '/ApppasswordForgot', component: () => import("../pages/AppPasswordForgot"), name: "apppasswardforgot", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/puriContentDeleteFinish', component: () => import("../pages/PuriContentDeleteFinish") },
    { path: '/setting', component: () => import("../pages/Setting"), meta: { tutorial: 'SETTING' } },
    { path: '/snsCancel/:sns', component: () => import("../pages/SNSCancel") },
    { path: '/terms', component: () => import("../pages/Terms") },
    { path: '/updateTerms', component: () => import("../pages/UpdateTerms") },
    { path: '/AppUpdateTerms', component: () => import("../pages/AppUpdateTerms"), name: "appupdateterms", meta: { headerDisabled: false, footerDisabled: false } },
    { path: '/Appterms', component: () => import("../pages/AppTerms"), name: "appterms", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/SCTransactions', component: () => import("../pages/SCTransactions") },
    { path: '/AppSCTransactions', component: () => import("../pages/AppSCTransactions"), name: "appsctransactions", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppPSTransactions', component: () => import("../pages/AppPSTransactions"), name: "apppstransactions", meta: { headerDisabled: true, footerDisabled: true } },
    { path: '/AppUpdatePSTransactions', component: () => import("../pages/AppUpdatePSTransactions"), name: "appupdatepstransactions", meta: { headerDisabled: false, footerDisabled: false } },
    { path: '/Application', component: () => import("../pages/Application") },
    { path: '/appfw/privacypolicy', component: () => import("../pages/Privacypolicy") },
    { path: '/appfw/location', component: () => import("../pages/Location") },
    { path: '/appfw/locationAll', component: () => import("../pages/LocationAll") },
    { path: '/appfw/locationFiz', component: () => import("../pages/LocationFiz") },
    { path: '/appfw/locationMeiroma', component: () => import("../pages/LocationMeiroma") },
    { path: '/appfw/locationLalamee', component: () => import("../pages/LocationLalamee") },
    { path: '/appfw/locationRomapi', component: () => import("../pages/LocationRomapi") },
    { path: '/appfw/locationBepiu', component: () => import("../pages/LocationBepiu") },
    { path: '/appfw/locationRomakyun', component: () => import("../pages/LocationRomakyun") },
    { path: '/appfw/locationIMyMerry', component: () => import("../pages/LocationIMyMerry") },
    { path: '/appfw/contact', component: () => import("../pages/Contact") },
    { path: '/dev/webtmp/appUpdateRelay.html', component: () => import("../pages/AppStore") }, // 暫定ストアリンク処理
    { path: '/Tutorial', component: () => import("../pages/Tutorial") },
    { path: '/Tutorial/:type', component: () => import("../pages/Tutorial") },
    { path: '/locatecode', component: () => import("../pages/Home"), meta: { tutorial: 'HOME' } }, // #16180のため追加、後々静的な説明ページが実装される予定
    { path: '/DL/:playerId', component: () => import("../pages/Dl"), meta: { tutorial: 'HOME' } }, // ロケテ版対応の為追加、後々ダウンロードの仕組みを入れる
    { path: '/DL', component: () => import("../pages/Dl") },
    { path: '/DlFinish', component: () => import("../pages/DlFinish"), name: "DlFinish", props: true },
    { path: '/Questionary', component: () => import("../pages/Questionary") },
    { path: '*', component: () => import("../pages/NotFound") },
    { path: '*', component: () => import("../pages/OutOfService") },
    { path: '/friendCampaign', component: () => import("../pages/FriendCampaign.vue"), },
    { path: '/friendCampaignHistory', component: () => import("../pages/FriendCampaignHistory.vue"), },
    { path: '/AppRomapi', component: () => import("../pages/AppRomapi.vue"), },
    { path: '/AppBepiu', component: () => import("../pages/AppBepiu.vue"), },
    { path: '/AppRomakyun', component: () => import("../pages/AppRomakyun.vue"), },
    { path: '/AppImymerry', component: () => import("../pages/AppImymerry.vue"), },
    { path: '/EnvironmentAttention', component: () => import("../pages/EnvironmentAttention.vue"), },
    { path: '/AlreadyDownloaded', component: () => import("../pages/AlreadyDownloaded.vue"), },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

import store from '../store'


router.beforeEach((to, from, next) => {
  if (
    to.path === '/' ||
    to.path === '/login' ||
    to.path === '/accountRegistration1' ||
    to.path === '/accountRegistration3' ||
    to.path === '/freeMemberRemovalFinish' ||
    to.path === '/AppfreeMemberRemovalFinish' ||
    to.path === '/newsList' ||
    to.path === '/appnewsList' ||
    to.path.startsWith('/newsDetail/') ||
    to.path.startsWith('/appnewsDetail/') ||
    to.path.startsWith('/error') ||
    to.path === '/passwordForgot' ||
    to.path === '/ApppasswordForgot' ||
    to.path.startsWith('/passwordReset') ||
    to.path.startsWith('/passwordChangeFinish') ||
    to.path.startsWith('/terms') ||
    to.path.startsWith('/updateTerms') ||
    to.path.startsWith('/AppUpdateTerms') ||
    to.path.startsWith('/Appterms') ||
    to.path.startsWith('/SCTransactions') ||
    to.path.startsWith('/AppSCTransactions') ||
    to.path.startsWith('/AppPSTransactions') ||
    to.path.startsWith('/AppUpdatePSTransactions') ||
    to.path.startsWith('/help') ||
    to.path.startsWith('/Application') ||
    to.path.startsWith('/Tutorial') ||
    to.path.startsWith('/locatecode') ||
    to.path.startsWith('/DL') ||
    to.path.startsWith('/faq') ||
    to.path.startsWith('/Appfaq') ||
    to.path.startsWith('/AboutWeb') ||
    to.path.startsWith('/AppaboutWeb') ||
    to.path.startsWith('/AboutWeb01') ||
    to.path.startsWith('/AppaboutWeb01') ||
    to.path.startsWith('/AboutWeb02') ||
    to.path.startsWith('/AppaboutWeb02') ||
    to.path.startsWith('/AppaboutWeb02_1') ||
    to.path.startsWith('/AboutWeb03') ||
    to.path.startsWith('/AppaboutWeb03') ||
    to.path.startsWith('/AboutWeb04') ||
    to.path.startsWith('/AppaboutWeb04') ||
    to.path.startsWith('/AboutWeb05') ||
    to.path.startsWith('/AppaboutWeb05') ||
    to.path.startsWith('/AboutWeb06') ||
    to.path.startsWith('/AppaboutWeb06') ||
    to.path.startsWith('/AboutWeb07') ||
    to.path.startsWith('/AppaboutWeb07') ||
    to.path.startsWith('/AboutWeb08') ||
    to.path.startsWith('/AppaboutWeb08') ||
    to.path.startsWith('/AboutWeb09') ||
    to.path.startsWith('/AppaboutWeb09') ||
    to.path.startsWith('/AboutWeb10') ||
    to.path.startsWith('/AppaboutWeb10') ||
    to.path.startsWith('/AboutARpuri') ||
    to.path.startsWith('/AppAboutARpuri') ||
    to.path.startsWith('/AboutAppsubscription') ||
    to.path.startsWith('/AppAboutAppsubscription') ||
    to.path.startsWith('/AboutFiz') ||
    to.path.startsWith('/AppaboutFiz') ||
    to.path.startsWith('/AboutFiz01') ||
    to.path.startsWith('/AppaboutFiz01') ||
    to.path.startsWith('/AboutFiz02') ||
    to.path.startsWith('/AppaboutFiz02') ||
    to.path.startsWith('/AboutFiz03') ||
    to.path.startsWith('/AppaboutFiz03') ||
    to.path.startsWith('/AboutMeiyromantic') ||
    to.path.startsWith('/Aboutmeityromantic01') ||
    to.path.startsWith('/Aboutmeityromantic02') ||
    to.path.startsWith('/Aboutmeityromantic03') ||
    to.path.startsWith('/AppAboutMeiyromantic') ||
    to.path.startsWith('/AppAboutmeityromantic01') ||
    to.path.startsWith('/AppAboutmeityromantic02') ||
    to.path.startsWith('/AppAboutmeityromantic03') ||
    to.path.startsWith('/AboutLalamee') ||
    to.path.startsWith('/AboutLalamee01') ||
    to.path.startsWith('/AboutLalamee02') ||
    to.path.startsWith('/AboutLalamee03') ||
    to.path.startsWith('/AppaboutLalamee') ||
    to.path.startsWith('/AppaboutLalamee01') ||
    to.path.startsWith('/AppaboutLalamee02') ||
    to.path.startsWith('/AppaboutLalamee03') ||
    to.path.startsWith('/AboutROMAPI') ||
    to.path.startsWith('/AboutROMAPI01') ||
    to.path.startsWith('/AboutROMAPI02') ||
    to.path.startsWith('/AboutROMAPI03') ||
    to.path.startsWith('/AppaboutROMAPI') ||
    to.path.startsWith('/AppaboutROMAPI01') ||
    to.path.startsWith('/AppaboutROMAPI02') ||
    to.path.startsWith('/AppaboutROMAPI03') ||
    to.path.startsWith('/AboutBepiu') ||
    to.path.startsWith('/AboutBepiu01') ||
    to.path.startsWith('/AboutBepiu02') ||
    to.path.startsWith('/AboutBepiu03') ||
    to.path.startsWith('/AppaboutBepiu') ||
    to.path.startsWith('/AppaboutBepiu01') ||
    to.path.startsWith('/AppaboutBepiu02') ||
    to.path.startsWith('/AppaboutBepiu03') ||
    to.path.startsWith('/AboutRomakyun') ||
    to.path.startsWith('/AboutRomakyun01') ||
    to.path.startsWith('/AboutRomakyun02') ||
    to.path.startsWith('/AboutRomakyun03') ||
    to.path.startsWith('/AppaboutRomakyun') ||
    to.path.startsWith('/AppaboutRomakyun01') ||
    to.path.startsWith('/AppaboutRomakyun02') ||
    to.path.startsWith('/AppaboutRomakyun03') ||
    to.path.startsWith('/AboutIMyMerry') ||
    to.path.startsWith('/AboutIMyMerry01') ||
    to.path.startsWith('/AboutIMyMerry02') ||
    to.path.startsWith('/AboutIMyMerry03') ||
    to.path.startsWith('/AppaboutIMyMerry') ||
    to.path.startsWith('/AppaboutIMyMerry01') ||
    to.path.startsWith('/AppaboutIMyMerry02') ||
    to.path.startsWith('/AppaboutIMyMerry03') ||
    to.path.startsWith('/Application') ||
    to.path.startsWith('/appfw/') ||
    to.path.startsWith('/dev/webtmp/appUpdateRelay.html') ||
    to.path.startsWith('/searchShop') ||
    to.path.startsWith('/couponGet') ||
    to.path.startsWith('/AboutApplication') ||
    to.path.startsWith('/newsTinyTAN') ||
    to.path.startsWith('/newsTinyTan_Butter') ||
    to.path.startsWith('/news_TinyTAN_Sweet') ||
    to.path.startsWith('/news_P5T') ||
    to.path.startsWith('/newsPokePeace') ||
    to.path.startsWith('/newsPeachShowtime') ||
    to.path.startsWith('/newsTXT') ||
    to.path.startsWith('/newsBEFIRST') ||
    to.path.startsWith('/newsD100') ||
    to.path.startsWith('/news_TinyTAN_Permission') ||
    to.path.startsWith('/AppRomapi') ||
    to.path.startsWith('/AppBepiu') ||
    to.path.startsWith('/AppRomakyun') ||
    to.path.startsWith('/AppImymerry') ||
    to.path.startsWith('/EnvironmentAttention') ||
    to.path.startsWith('/AlreadyDownloaded') ||
    // to.path.startsWith('/test') ||
    store.getters.isLogin
  ) {
    // 戻るボタン表示
    if(to.path === '/terms'){
      router.referrer = from
    }


    if (to.path === '/memberBenefits') {
      store.dispatch('savePaidMemberRegistrationTappedPagePath', from.path)
    }
    if (store.getters.isLogin && (
      to.path === '/login'
    )) {
      next({ path: '/' })
      return
    }
    next()
  } else {
    next({ path: '/login', query: { to: to.path } })
  }
})

// router.afterEach((to) => {
//   if(to.path !== "/Tutorial" && store.getters.isLogin) {
//     if(!store.getters.tutorialByPath('SITE') && to.path ==='/') {
//       router.push({ path: '/Tutorial/SITE', query: { path: to.path } })
//     }
//     // else if(to.meta.tutorial !== undefined  && !store.getters.tutorialByPath(to.meta.tutorial)) {
//     //   router.push({ path: `/Tutorial/${to.meta.tutorial}`, query: { path: to.path } })
//     // }
//   }
// })

router.afterEach((to) => {
  /*global gtag*/
  gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS_ID, { 'page_path': to.path });
})

export default router
